import { render, staticRenderFns } from "./vip_orderList.vue?vue&type=template&id=d2eff34c&scoped=true&"
import script from "./vip_orderList.vue?vue&type=script&lang=js&"
export * from "./vip_orderList.vue?vue&type=script&lang=js&"
import style0 from "./vip_orderList.vue?vue&type=style&index=0&id=d2eff34c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2eff34c",
  null
  
)

export default component.exports